"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const EmailTemplate_1 = require("./EmailTemplate");
const EmailTemplateVersion_1 = require("./EmailTemplateVersion");
const auth_1 = require("../auth");
let EmailTemplateVersionDeployment = class EmailTemplateVersionDeployment extends OsmosysBaseEntity_1.OsmosysBaseEntity {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.User),
    typeorm_1.ManyToOne(() => auth_1.User, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateVersionDeployment.prototype, "creatingUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => EmailTemplateVersion_1.EmailTemplateVersion),
    typeorm_1.ManyToOne(() => EmailTemplateVersion_1.EmailTemplateVersion, version => version.deployments),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateVersionDeployment.prototype, "version", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => EmailTemplate_1.EmailTemplate),
    typeorm_1.ManyToOne(() => EmailTemplate_1.EmailTemplate, template => template.deployments),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateVersionDeployment.prototype, "template", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.RelationId((obj) => obj.template),
    tslib_1.__metadata("design:type", Number)
], EmailTemplateVersionDeployment.prototype, "templateId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ nullable: false }),
    class_validator_1.IsIn(['production', 'staging']),
    tslib_1.__metadata("design:type", String)
], EmailTemplateVersionDeployment.prototype, "environment", void 0);
tslib_1.__decorate([
    type_graphql_1.Field({ nullable: true }),
    typeorm_1.Column({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], EmailTemplateVersionDeployment.prototype, "espResponse", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], EmailTemplateVersionDeployment.prototype, "successful", void 0);
EmailTemplateVersionDeployment = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity()
], EmailTemplateVersionDeployment);
exports.EmailTemplateVersionDeployment = EmailTemplateVersionDeployment;
class EmailTemplateVersionDeploymentEntity extends EmailTemplateVersionDeployment {
    toString() {
        return `Template version deployment #${this.id}`;
    }
}
exports.EmailTemplateVersionDeploymentEntity = EmailTemplateVersionDeploymentEntity;
//# sourceMappingURL=EmailTemplateVersionDeployment.js.map